import { ALIGN_BOTTOM } from "../../../actions/index";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case ALIGN_BOTTOM:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          if (
            old_layer.width > 0 &&
            (old_layer.allow_image || old_layer.allow_text)
          ) {
            const layerHeight = old_layer.height;

            // Get furthest bottom positioned text element
            const baseTextBottomPosition = Math.max.apply(
              Math,
              old_layer.text_elements.map((obj) => {
                return obj.height + obj.top_position;
              }),
            );

            // Get furthest bottom positioned image element
            const baseImageBottomPosition = Math.max.apply(
              Math,
              old_layer.image_elements.map((obj) => {
                return obj.height + obj.top_position;
              }),
            );

            // Assign the base top position for all elements to the highest top position value of both images and text
            const baseBottomPosition =
                baseTextBottomPosition > baseImageBottomPosition
                  ? baseTextBottomPosition
                  : baseImageBottomPosition,
              newTopPosition = layerHeight - baseBottomPosition;

            return {
              ...old_layer,
              text_elements: old_layer.text_elements.map((element) => {
                let newTop = element.top_position + newTopPosition;
                const totalElHeight = element.height + element.top_position;

                if (totalElHeight > layerHeight) {
                  newTop = layerHeight - element.height;
                } else if (newTop < 0) {
                  newTop = 0;
                }

                return {
                  ...element,
                  top_position: newTop,
                };
              }),
              image_elements: old_layer.image_elements.map((element) => {
                let newTop = element.top_position + newTopPosition;
                const totalElHeight = element.height + element.top_position;

                if (totalElHeight > layerHeight) {
                  newTop = layerHeight - element.height;
                } else if (newTop < 0) {
                  newTop = 0;
                }

                return {
                  ...element,
                  top_position: newTop,
                };
              }),
            };
          } else {
            return {
              ...old_layer,
            };
          }
        }),
      };

    default:
      return state;
  }
}
